export interface IProjectStats {
  totalProjects: number;
  completedProjects: number;
  inprogressProjects: number;
  onholdProjects: number;
}

export enum ENUM_PROJECT_STATUSES {
  NOT_STARTED = "not_started",
  IN_PROGRESS = "in_progress",
  COMPLETED = "completed",
  ON_HOLD = "on_hold",
}

export interface ISingleProject {
  id: number;
  name: string;
  companyId: number;
  description: string;
  branchId: number;
  branch: {
    id: number;
    name: string;
    code: string;
  };
  departmentId: number;
  status: ENUM_PROJECT_STATUSES;
  projectOwner: string;
  image: string;
  startDate: string;
  endDate: string;
  createdBy: number;
  deletedAt: Date | null;
  createdAt: string;
  updatedAt: string;
  department: {
    id: number;
    name: string;
  };
  projectManagers: {
    id: number;
    name: string;
    profileImage: string | null;
  }[];
  projectTeams: {
    id: number;
    teamId: number;
    projectId: number;
    createdAt: string;
    updatedAt: string;
    deletedAt: string | null;
    team: {
      id: number;
      name: string;
      image: string | null;
      teamMembers: {
        id: number;
        userId: number;
        role: {
          isTeamManager: boolean;
        };
      }[];
    };
  }[];
}

export interface ISingleProjectAttachment {
  id: number;
  projectId: number;
  fileUrl: string;
  name: string;
  fileType: string;
  fileId: string;
  description: string | null;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
}

export enum ENUM_PROJECT_KPI_STATUSES {
  TODO = "todo",
  IN_PROGRESS = "in_progress",
  COMPLETED = "completed",
}

export enum ENUM_PROJECT_OKR_STATUSES {
  TODO = "todo",
  IN_PROGRESS = "in_progress",
  COMPLETED = "completed",
}

export interface IAddProjectKPIPayload {
  name: string;
  description?: string;
  status: ENUM_PROJECT_KPI_STATUSES;
  isActive: boolean;
}

export interface ISingleKPI {
  id: number;
  projectId: number;
  name: string;
  description: string | null;
  isActive: boolean;
  status: ENUM_PROJECT_KPI_STATUSES;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
}

export interface ISingleKeyResult {
  id: number;
  objectiveId: number;
  name: string;
  progress: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
}

export interface ISingleOKR {
  id: number;
  projectId: number;
  name: string;
  description: string;
  isActive: boolean;
  status: ENUM_PROJECT_OKR_STATUSES;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  projectKeyResults: ISingleKeyResult[];
  krsCount: number;
}
